 export const getIsPending = (state) => state.apiCalls.apiCallCounter > 0;
